import styled from '@emotion/styled'
import { htmlStringSanitizer } from '@pharmac-extranet/shared'
import { SpacerDefs, spacer } from '@pharmac/ui'
import { PropsWithChildren } from 'react'

type ExtranetParagraphProps = SpacerDefs & PropsWithChildren

const ExtranetParagraphRoot = styled.div<ExtranetParagraphProps>`
  margin-top: 1rem;
  margin-bottom: 2rem;

  font-family: var(--font-family-primary);

  p {
    font-size: 16px;
  }

  ol,
  ul {
    padding-left: 1.5em;
  }
`

export const ExtranetParagraph = ({ children, ...props }: ExtranetParagraphProps) => {
  if (typeof children !== 'string') {
    return <ExtranetParagraphRoot>{children}</ExtranetParagraphRoot>
  }

  const styles = {
    ...spacer(props),
  }

  return (
    <ExtranetParagraphRoot
      style={styles}
      dangerouslySetInnerHTML={{
        __html: htmlStringSanitizer(children) ?? '',
      }}
    />
  )
}
